import * as React from 'react';
import {useState} from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import {createTheme} from '@mui/material/styles';
import LoginByPassword from "./sections/LoginByPassword";
import LoginByOtpStep1 from "./sections/loginByOtp/LoginByOtpStep1";
import LoginByOtpStep2 from "./sections/loginByOtp/LoginByOtpStep2";
import {AnimatePresence, motion} from "framer-motion"


const defaultTheme = createTheme();


const Index = () => {
    const [slideIndex, setSlideIndex] = useState(0);
    const next = () => setSlideIndex((prev) => prev + 1);
    const back = () => setSlideIndex((prev) => prev - 1);

    return (
        <Grid container component="main"
              sx={{
                  height: 'calc(100vh - 64px)',
                  fontFamily: "IRANSan,IRANSansFaNum,IRANSansFaNum",
                  margin: '30px,20px',
                  padding: '20px,40px'

              }}>
            <CssBaseline/>


            <Grid item md={7} xs={12} component={Paper} elevation={6} square>
                <Box
                    sx={{
                        my: {md: 8, xs: 0},
                        mx: {md: 4, xs: 0},
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        fontFamily: "IRANSan",

                        margin: '30px,20px'
                    }}
                >

                    <AnimatePresence mode={'wait'}>
                        <Grid item sx={{width: '100%', minHeight: 550}} xs={12}>
                            <motion.div
                                key={slideIndex}
                                initial={{filter: 'blur(5px)'}}
                                animate={{filter: 'blur(0)', transition: {duration: .3}}}
                                exit={{filter: 'blur(5px)', transition: {duration: .1}}}
                            >
                                {slideIndex === 0 && <LoginByPassword setSlideIndex={setSlideIndex}/>}
                                {slideIndex === 1 && <LoginByOtpStep1 setSlideIndex={setSlideIndex}/>}
                                {slideIndex === 2 &&
                                    <LoginByOtpStep2 pageIndex={slideIndex} setSlideIndex={setSlideIndex}/>}

                            </motion.div>
                        </Grid>
                    </AnimatePresence>

                </Box>

            </Grid>

            <Grid
                item
                xs={false}
                sm={false}
                md={5}
                sx={{
                    backgroundImage: `url(${require("../../../../assets/images/admin/login-banner.png")})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                }}
            />
        </Grid>
    );
};

export default Index;